import { useMutation } from "@tanstack/react-query";
import { sendLocalPasswordResetEmailAdminPortal } from "../services/AccountService";

export function useSendLocalPasswordResetEmailAdminPortal() {
    return useMutation({
        mutationFn: sendLocalPasswordResetEmailAdminPortal,
    });
}
